import { useEffect, useState, useMemo } from "react";
import { db } from "../services/firebase";
import { ref, push, set, update, remove, onValue } from "firebase/database";

export default function useQuestionCategories(domainId) {
    
    const [categories, setCategories] = useState({});
    const [loading, setLoading] = useState(true);

    const [modalOpen, setModalOpen] = useState(false);
    const [editData, setEditData] = useState(null);

    useEffect(() => {
        const categoryRef = ref(db, `QuestionCategory/${domainId}`);
        onValue(categoryRef, (snapshot) => {
            setCategories(snapshot.val() || {});
            setLoading(false);
        });
    }, [domainId]);

    const sortedCategories = useMemo(() => {
        return Object.entries(categories)
            .map(([id, item]) => ({ id, ...item }))
            .sort((a, b) => (a.orderId ?? 0) - (b.orderId ?? 0));
    }, [categories]);

    const createCategory = (name, description, orderId) => {
        const newRef = push(ref(db, `QuestionCategory/${domainId}`));

        return set(newRef, {
            name,
            description,
            orderId: Number(orderId),
            createdAt: Date.now(),
        });
    };

    const updateCategory = (id, name, description, orderId) => {
        return update(ref(db, `QuestionCategory/${domainId}/${id}`), {
            name,
            description,
            orderId: Number(orderId),
        });
    };

    const deleteCategory = (id) => {
        return remove(ref(db, `QuestionCategory/${domainId}/${id}`));
    };

    const openCreateModal = () => {
        setEditData(null);
        setModalOpen(true);
    };

    const openEditModal = (id, data) => {
        setEditData({ id, ...data });
        setModalOpen(true);
    };

    const handleSave = (name, description, orderId) => {
        if (editData) {
            return updateCategory(editData.id, name, description, orderId);
        } else {
            return createCategory(name, description, orderId);
        }
    };

    return {
        loading,
        sortedCategories,

        modalOpen,
        setModalOpen,
        editData,

        openCreateModal,
        openEditModal,

        deleteCategory,
        handleSave,
    };
}
